<span #stickyPopover="stickyPopover"
      [stickyPopover]="popContent"
      [autoClose]="false"
      [animation]="false"
      [openDelay]="300"
      popoverClass='footprint-popover'
      container="body"
      triggers="manual"
      placement="auto">
</span>

<ng-template #popContent>
  <div class="div-ellipsis">
    <span class="text-primary font-weight-bold">Search radius: </span>
    <span>{{searchRadius?.radius}} arcmin</span>
</div>
  
</ng-template>
